<template lang="pug">
  v-dialog(
    v-model="show",
    transition="slide-y-reverse-transition",
    persistent,
    max-width="450")
    v-card.delete-form.pa-3
      v-card-text.text-xs-center.mb-4
        slot(name="title")
      v-card-actions
        v-spacer
        v-btn(large @click.prevent="cancel").mx-3 Отмена
        v-btn(
          large,
          outline,
          color="error",
          :loading="loading",
          :disabled="loading",
          @click.prevent="remove").mx-3 Удалить
        v-spacer
</template>

<script>
export default {
  name: 'DeleteDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    dispatchType: {
      type: String,
      default: ''
    }
  },
  created() {
    this.subscribeToMutations()
  },
  methods: {
    cancel() {
      this.$emit('close-dialog')
    },
    remove() {
      switch (this.dispatchType) {
        case 'db':
          this.$emit('delete-db')
          break
        case 'employee':
          this.$emit('delete-employee')
          break
        case 'record':
          this.$emit('delete-record')
          break
        case 'field':
          this.$emit('delete-field')
          break
        case 'tyndyk':
          this.$emit('delete-tyndyk')
          break
        case 'organisation':
          this.$emit('delete-organisation')
          break
        case 'division':
          this.$emit('delete-division')
          break
        case 'position':
          this.$emit('delete-position')
      }
    },
    subscribeToMutations() {
      this.$store.subscribe((mutation, state) => {
        switch (mutation.type) {
          case 'DELETE_DB_SUCCESS':
            this.cancel()
            break
          case 'DELETE_EMPLOYEE_SUCCESS':
            this.cancel()
            break
          case 'DELETE_RECORD_SUCCESS':
            this.cancel()
            this.$emit('close-edit-record-dialog')
            break
          case 'DELETE_TYNDYK_ITEM_SUCCESS':
            this.cancel()
            break
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-form {
  border-radius: 5px;
  font-size: 1.4rem;
  .v-btn {
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/DeleteDialog/DeleteDialog.vue